import { render, staticRenderFns } from "./CourseGroupIndex.vue?vue&type=template&id=f541abf4"
import script from "./CourseGroupIndex.vue?vue&type=script&lang=ts"
export * from "./CourseGroupIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports